// Services
import { EeoiFleetSchema, getEeoiFleetScores } from '@services/index';
// Schemas
import { QueryFunctionContext } from '@tanstack/react-query';
// Types
import { EeoiFleetScoresParams } from './eeoiFleetScoresController.types';
import { isAfter } from 'date-fns';

/**
 * Fetches EEOI fleet scores for a specific client within a given date range.
 *
 * @param {QueryFunctionContext} queryKey - The ID of the client.
 * @param {EeoiFleetScoresParams} queryKey.params - The EeoI fleet scores params
 * @returns {Promise<EeoiFleet>} - A promise that resolves to the fetched EEOI fleet scores.
 */
export const eeoiFleetScoresController = async ({ queryKey }: QueryFunctionContext) => {
  const [_, params] = queryKey;
  const { startDate, endDate } = params as EeoiFleetScoresParams;

  const defaultStartDate = new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10);
  const defaultEndDate = new Date(Date.UTC(new Date().getUTCFullYear() + 1, 0, 1)).toISOString().slice(0, 10);
  const todayUtc = new Date().toISOString().slice(0, 10);
  const normalizedEndDate =
    endDate === todayUtc || isAfter(new Date(endDate), new Date(todayUtc))
      ? new Date(Date.UTC(new Date().getUTCFullYear() + 1, 0, 1)).toISOString().slice(0, 10)
      : endDate;
  const isDefaultDateRange = startDate === defaultStartDate && normalizedEndDate === defaultEndDate;
  const { data } = await getEeoiFleetScores(startDate, normalizedEndDate, isDefaultDateRange);

  return EeoiFleetSchema.parse(data);
};
